export default {
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    }
  },
  mounted: function mounted() {
    // In order to fix the click on menu on the ios device will trigger the mouseeleave bug
    // https://github.com/PanJiaChen/vue-element-admin/issues/1135
    this.fixBugIniOS();
  },
  methods: {
    fixBugIniOS: function fixBugIniOS() {
      var _this = this;

      var $submenu = this.$refs.submenu;

      if ($submenu) {
        var handleMouseleave = $submenu.handleMouseleave;

        $submenu.handleMouseleave = function (e) {
          if (_this.device === "mobile") {
            return;
          }

          handleMouseleave(e);
        };
      }
    }
  }
};